// Session-scoped like the chat itself: an open panel survives navigations in this tab, while a new
// tab still starts closed.
const OPEN_KEY = 'aiAssistantOpen';

export function readOpenState(): boolean {
  try {
    return window.sessionStorage.getItem(OPEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function writeOpenState(open: boolean) {
  try {
    if (open) {
      window.sessionStorage.setItem(OPEN_KEY, 'true');
    } else {
      window.sessionStorage.removeItem(OPEN_KEY);
    }
  } catch {
    // The panel just starts closed on the next page.
  }
}
